<template>
    <cl-header />
    <status-notifications />
    <reload-prompt />
    <section
        class="section"
        style="padding-top: 1.5rem">
        <router-view :key="refreshKey" />
    </section>
</template>
<script>
    import ClHeader from '@/shared/ClHeader.vue';
    import ReloadPrompt from '@/apps/reloadPrompt/ReloadPrompt.vue';
    import StatusNotifications from '@/shared/StatusNotifications.vue';

    export default {
        name: 'CommonLibraryApp',
        components: { StatusNotifications, ClHeader, ReloadPrompt },
        data() {
            return {
                refreshKey: 0
            };
        },
        created() {
            this.$watch(
                () => this.$route.meta.refreshKey?.(this.$route),
                (newKey, oldKey) => {
                    if (newKey !== oldKey && newKey !== undefined && oldKey !== undefined) {
                        this.refreshKey++;
                    }
                }
            );
        }
    };
</script>
